import axios from "axios";
import { apiAddress } from "../../config/server";
import * as types from "./actionTypes";

export function startLoadingPosts() {
  return { type: types.GET_POSTS_STARTED };
}

export function loadPostsFulfilled(data) {
  return {
    type: types.GET_POSTS_FULFILLED,
    payload: { posts: data.posts, persons: data.persons },
  };
}

export function loadPostsRejected(error) {
  return { type: types.GET_POSTS_REJECTED, error: error.message };
}

// export function loadAuthorsSuccess(authors) {
//     return {type: types.LOAD_AUTHORS_SUCCESS, authors };
// }

export function getPosts() {
  return (dispatch) => {
    dispatch(startLoadingPosts());
    return axios
      .get(`${apiAddress}/api/post/`)
      .then((response) => {
        dispatch(loadPostsFulfilled(response.data));
        return response.data;
      })
      .catch((er) => {
        dispatch(loadPostsRejected(er));
      });
  };
}
